import React, { useState } from "react";
import uuid from 'react-uuid';
import LinkWrapper from "../LinkWrapper";
import DownloadButton from "../UI/DownloadButton";
import { Collapse } from "react-collapse";
import { getDownloadPageUrl } from "../../routes/clientUrls";
import { IPlatfrom } from "../../utils/fetchers/types";
import { downloadButtonText } from "../../utils/helpers";
import dropdownIcon from '../../assets/icons/keyboard_arrow_down.svg'
import { size } from "../UI/DownloadButton/DownloadButton";

import styles from './OtherPlatforms.module.css'

type TOtherPlatforms = {
  client: string,
  platforms: IPlatfrom[];
  size?: size,
  onClick?: () => void;
  needModal?: boolean;
  version: string;
  setCurrentFileName?: React.Dispatch<React.SetStateAction<string>>
}

const OtherPlatforms: React.FC<TOtherPlatforms> = ({ setCurrentFileName, version, needModal, onClick, size, platforms, client }) => {
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);
  const handleCollapse = () => setIsCollapseOpen(!isCollapseOpen);

  return (
    (platforms.length >= 1)
      ?
      <div className={styles.wrapper}>
        <div
          onClick={handleCollapse}
          className={isCollapseOpen ? `${styles.labelWrapper}` : `${styles.labelWrapper} ${styles.open}`}
        >
          <div className={`${styles.title} ${styles[size || "lg"]}`}> Other platforms</div>
          <img
            src={dropdownIcon}
            className={isCollapseOpen ? `${styles.icon} ${styles.rotate}` : styles.icon}
            alt="icon"
          />
        </div>
        <Collapse isOpened={isCollapseOpen}>
          <div className={styles.buttonsWrapper}>
            {platforms.map((platform) =>
              <LinkWrapper
                href={getDownloadPageUrl(platform.fileName)}
                condition={!needModal}
                key={uuid()}
              >
                <DownloadButton
                  variant="outline"
                  onClick={needModal ? onClick : undefined}
                  size={size || 'lg'}
                  key={uuid()}
                  fileName={platform.fileName}
                  text={downloadButtonText(client, platform.platform)}
                  platform={platform.platform}
                  setCurrentFileName={setCurrentFileName}
                />
              </LinkWrapper>
            )}
          </div>
        </Collapse>
      </div>
      :
      <></>
  )
};

export default OtherPlatforms;